import styled from 'styled-components';

/** Вторичная кнопка: name white/register или явный type white (например «Очистить»). */
const isSecondaryStyle = ({ name, type }) =>
  name === 'white' || name === 'register' || type === 'white';

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 116px;
  height: 44px;
  border-radius: 16px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.17;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
  transition-property: transform;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  color: ${p =>
    isSecondaryStyle(p)
      ? p.theme.colors.main.orangeMain
      : '#ffffff'};
  background-color: ${p => {
    if (isSecondaryStyle(p)) {
      return p.theme.ui.scheme === 'dark'
        ? p.theme.colors.main.orangeLight
        : p.theme.colors.main.white;
    }
    return p.theme.colors.main.orangeMain;
  }};

  border: ${p =>
    isSecondaryStyle(p) && p.theme.ui.scheme === 'dark'
      ? `1px solid ${p.theme.colors.main.grayLight}`
      : 'none'};
  box-shadow: ${p => {
    if (isSecondaryStyle(p)) {
      return p.theme.ui.scheme === 'dark'
        ? '0 4px 16px rgba(0, 0, 0, 0.35)'
        : '4px 4px 16px rgba(170, 178, 197, 0.25)';
    }
    return '4px 4px 16px rgba(255, 107, 8, 0.25)';
  }};

  &:hover,
  &:focus {
    color: ${p => p.theme.colors.main.orangeMain};
    background-color: ${p => p.theme.colors.main.orangeLight};
    box-shadow: 4px 4px 16px rgba(255, 107, 8, 0.25);
    transform: scale(1.05);
  }
`;

export default StyledButton;
